import { Type } from 'class-transformer';
import { IsArray, IsDefined, IsString, ValidateNested } from 'class-validator';
import { BaseDto } from '../../@base/base.dto';
import { ContactInfosDto } from '../../administrative';
import { UserId } from '../../types';
import { UserIdentityPopulateAvatarDto } from './populate/user-identity-populate-avatar.dto';

export class UserSummaryDto extends BaseDto<UserId> {
  @ValidateNested()
  @Type(() => UserIdentityPopulateAvatarDto)
  @IsDefined()
  identity!: UserIdentityPopulateAvatarDto;

  @ValidateNested()
  @Type(() => ContactInfosDto)
  @IsDefined()
  contactInfos!: ContactInfosDto;

  @IsDefined()
  @IsArray()
  @IsString({ each: true })
  roles!: string[];
}
